"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenOtrDataset = void 0;
const interfaces_1 = require("@build-5/interfaces");
const common_1 = require("./common");
class TokenOtrDataset extends common_1.DatasetClass {
    constructor() {
        super(...arguments);
        this.sellBaseToken = (params) => {
            if (!Object.values(interfaces_1.Network).includes(params.symbol.toLowerCase())) {
                throw Error('Invalid base token symbol');
            }
            return new common_1.OtrRequest(this.otrAddress, Object.assign(Object.assign({}, params), { requestType: interfaces_1.TangleRequestType.SELL_TOKEN }), Math.floor((params.count || 0) * (params.price || 0)));
        };
        this.sellMintedToken = (tokenId, params) => new common_1.OtrRequest(this.otrAddress, Object.assign(Object.assign({}, params), { requestType: interfaces_1.TangleRequestType.SELL_TOKEN }), undefined, { amount: BigInt(params.count || 0), id: tokenId });
        this.buyToken = (params) => new common_1.OtrRequest(this.otrAddress, Object.assign(Object.assign({}, params), { requestType: interfaces_1.TangleRequestType.BUY_TOKEN }), Math.floor((params.count || 0) * (params.price || 0)));
        this.stake = (tokenId, count, params) => new common_1.OtrRequest(this.otrAddress, Object.assign({ requestType: interfaces_1.TangleRequestType.STAKE }, params), undefined, { amount: BigInt(count), id: tokenId });
        this.claimAirdrops = (params) => new common_1.OtrRequest(this.otrAddress, Object.assign(Object.assign({}, params), { requestType: interfaces_1.TangleRequestType.CLAIM_MINTED_AIRDROPS }));
    }
}
exports.TokenOtrDataset = TokenOtrDataset;
